// --------------------------------------------------------------
// Created On: 2023-11-27
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./SelectAssetsControl.module.scss";

// Button for selecting assets.
export default function SelectAssetsControl(props: Props): Component {
  return (
    <div className={styles.body}>
      <span>Select assets to update</span>
      <br />
      <button className="btn btn-primary m-3" type="button" onClick={() => props.onSelect()}>
        Select Assets
      </button>
    </div>
  );
}

interface Props {
  onSelect: () => void;
}
